import { createElement, memo, forwardRef } from 'react';
import { Animated as Component } from "./Animated.js";
const Animated = memo(forwardRef((props, forwardedRef) => (createElement(Component, {
    elementRef: forwardedRef,
    ...props
}))));
export * from "./Animated.js";
export { Animated };
